import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mode", "invitePanel", "linkPanel", "tab", "submitButton"]

  connect() {
    this.syncPanels()
  }

  switchMode() {
    this.syncPanels()
  }

  selectTab(event) {
    const mode = event.currentTarget.dataset.mode
    if (!mode) return

    this.modeTargets.forEach((input) => {
      input.checked = input.value === mode
    })
    this.syncPanels()
  }

  syncPanels() {
    const mode = this.selectedMode()

    this.invitePanelTarget.classList.toggle("hidden", mode !== "invite")
    this.linkPanelTarget.classList.toggle("hidden", mode !== "link")

    this.toggleRequired(this.invitePanelTarget, mode === "invite")
    this.toggleRequired(this.linkPanelTarget, mode === "link")
    this.syncTabs(mode)
    this.syncSubmitButton(mode)
    this.element.dispatchEvent(new CustomEvent("prescreen:refresh-selects", { bubbles: true }))
  }

  selectedMode() {
    return this.modeTargets.find((input) => input.checked)?.value || "invite"
  }

  syncTabs(mode) {
    if (!this.hasTabTarget) return

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.mode === mode
      tab.classList.toggle("border-blue-600", active)
      tab.classList.toggle("text-blue-600", active)
      tab.classList.toggle("border-transparent", !active)
      tab.classList.toggle("text-gray-600", !active)
    })
  }

  syncSubmitButton(mode) {
    if (!this.hasSubmitButtonTarget) return

    const linkLabel = this.element.dataset.linkSubmitLabel || "Grant access"
    this.submitButtonTarget.value = mode === "invite" ? "Send invitation" : linkLabel
  }

  toggleRequired(panel, required) {
    panel.querySelectorAll("input, select, textarea").forEach((field) => {
      if (field.type === "radio") return
      field.required = required
    })
  }
}
